import { render } from "./investment-level-panel.vue?vue&type=template&id=24b74c80&scoped=true&ts=true"
import script from "./investment-level-panel.vue?vue&type=script&lang=ts"
export * from "./investment-level-panel.vue?vue&type=script&lang=ts"

import "./investment-level-panel.vue?vue&type=style&index=0&id=24b74c80&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b74c80"]])

export default __exports__